// 环境 01=生产，02=测试
const env = '01'

export default {
  getEnv () {
    return env
  },
  getEnvUrl () {
    if (env == '01') {//正式环境
      return 'http://dltcczf.clouparking.cn/'
    } else if (env == '02') {
      return 'https://15j406k165.imdo.co/'// 邱桂玲
      // return 'https://56a9j12548.goho.co/'// 陈聪颖
      // return 'https://553f98052i.zicp.fun/' //陈凡
      // return 'http://192.168.1.76:8099/' //宝荣
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/request/env.js